import PropTypes from 'prop-types';

import { useTheme } from '@zenbusiness/zui/styles';

import { SubscriptionResultStep } from './SubscriptionResultStep';
import { SUCCESS_ILLUSTRATION, ERROR_ILLUSTRATION } from '../constants';

const cancelButtonRowSx = (theme) => ({
  '& > *': { width: '100%' },
  [theme.breakpoints.up('sm')]: {
    '& > *': { width: 'auto' },
    '& > :first-of-type': { order: 2 },
    '& > :last-child': { order: 1 }
  }
});

export function SubscriptionCancelResult({
  success,
  onReturnToSubscriptions,
  onReturnToDashboard,
  onContactUs,
  service
}) {
  const theme = useTheme();
  const serviceClickstream = service
    ? { dynamicProperties: { subscriptionService: service } }
    : {};

  return (
    <SubscriptionResultStep
      success={success}
      successIllustrationSrc={SUCCESS_ILLUSTRATION}
      errorIllustrationSrc={ERROR_ILLUSTRATION}
      successHeadingMessageId="dashboard.subscriptionCancel.result.success.heading"
      successBodyMessageId="dashboard.subscriptionCancel.result.success.body"
      errorHeadingMessageId="dashboard.subscriptionCancel.result.error.heading"
      errorBodyMessageId="dashboard.subscriptionCancel.result.error.body"
      successButtons={[
        {
          labelMessageId: 'dashboard.subscriptionCancel.result.returnToSubscriptions',
          onClick: onReturnToSubscriptions,
          variant: 'contained',
          clickstreamProps: {
            elementName: 'cancel_trial_return_subscriptions',
            ...serviceClickstream
          }
        },
        {
          labelMessageId: 'dashboard.subscriptionCancel.result.returnToDashboard',
          onClick: onReturnToDashboard,
          variant: 'outlined',
          clickstreamProps: {
            elementName: 'cancel_trial_return_dashboard',
            ...serviceClickstream
          }
        }
      ]}
      errorButtons={[
        {
          labelMessageId: 'dashboard.subscriptionCancel.result.contactUs',
          onClick: onContactUs,
          variant: 'contained',
          clickstreamProps: {
            elementName: 'cancel_trial_contact_us_result',
            ...serviceClickstream
          }
        },
        {
          labelMessageId: 'dashboard.subscriptionCancel.result.returnToSubscriptions',
          onClick: onReturnToSubscriptions,
          variant: 'outlined',
          clickstreamProps: {
            elementName: 'cancel_trial_return_subscriptions',
            ...serviceClickstream
          }
        }
      ]}
      illustrationSize={220}
      illustrationSx={{ width: { xs: 160, sm: 220 } }}
      buttonRowSx={cancelButtonRowSx(theme)}
    />
  );
}

SubscriptionCancelResult.propTypes = {
  success: PropTypes.bool.isRequired,
  onReturnToSubscriptions: PropTypes.func.isRequired,
  onReturnToDashboard: PropTypes.func.isRequired,
  onContactUs: PropTypes.func.isRequired,
  service: PropTypes.string
};
